import { render } from "./pushTask.vue?vue&type=template&id=1fb447a9&scoped=true"
import script from "./pushTask.vue?vue&type=script&lang=js"
export * from "./pushTask.vue?vue&type=script&lang=js"

import "./pushTask.vue?vue&type=style&index=0&id=1fb447a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb447a9"]])

export default __exports__